import { CoreIcon } from '../core-icon';
import walletSVG from '../../../src/images/icons/wallet.svg';

export const WalletIcon = props => {
  return <CoreIcon src={walletSVG} {...props} />;
};
